import AgentLayout from './AgentLayout';
import BusinessesPanel from './BusinessesPanel';

function AgentBusinesses() {
  return (
    <AgentLayout>
            <BusinessesPanel allowTemplateManagement={false} allowDelete={false} />
    </AgentLayout>
  );
}

export default AgentBusinesses;